import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? m[1] : null;
    if (!sid) {
      navigate("/admin", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/session`, {}, { headers: { "X-Session-ID": sid }, withCredentials: true })
      .finally(() => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      });
  }, [navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Outfit, sans-serif", color: "#123D5B" }}>
      Accesso in corso…
    </div>
  );
}
